import css from "classnames";
import { gql } from "graphql-tag";
import React from "react";
import { useQuery } from "@apollo/client";
import { LoadingSpinner } from "components/graphql-views";
import { LinkButton } from "components/haven-design/buttons";
import { Viewer } from "components/auth/types";
import { templateGroups, templateGroups_templateGroups as templateGroup } from "types/gql-types";
import { SettingsHeader } from "../settings/pages/settings-header";
import TemplateTable from "./template-table";
import styles from "./template-table.module.css";

const accessType = ({ isOrgTemplate, isPropertyTemplate }: templateGroup) => {
  if (isOrgTemplate) {
    return "Organization" as const;
  } else if (isPropertyTemplate) {
    return "Property" as const;
  }
  return "Owned" as const;
};

/** takes Template Group GQL data and creates a minimal set of fields */
const formatTemplateData = (tmpData: templateGroup) => ({
  ...tmpData,
  accessType: accessType(tmpData),
});


export const TEMPLATE_DASHBOARD_ROUTE = "/dash/manager/settings/templates";

const USER_TEMPLATES = gql`
  query templateGroups {
    templateGroups {
      id
      name
      isOrgTemplate
      isPropertyTemplate
      organizationId
      userId
      user {
        profile {
          fullName
        }
      }
      properties {
        name
      }
      canModify
      templates {
        id
        type
        isEmpty
        updatedAt
      }
    }
  }
`;

type Props = {
  viewer: Viewer;
}

const TemplateGroups: React.FC<Props> = (props: Props) => {
  const { viewer } = props;
  const { loading, data, error, refetch } = useQuery<templateGroups>(USER_TEMPLATES, {
    fetchPolicy: "cache-and-network",
  });

  if (loading) return <LoadingSpinner />;
  if (error || !data) return <div>Server Error</div>;
  const formattedData =
    data.templateGroups.length > 0 ? data.templateGroups.map(formatTemplateData) : [];

  return (
    <div style={{ width: "100%" }}>
      <div>
        <div className={css(styles.header, "margin-bottom-l")}>
          <SettingsHeader title="Templates" />
          <div className={styles.buttons}>
            <LinkButton size="L" color="primary" to="new">
              New Template
            </LinkButton>
          </div>
        </div>
        <div style={{ overflowX: "auto", overflowY: "hidden" }}>
          <TemplateTable rowData={formattedData} viewer={viewer} refetchTemplates={refetch} />
        </div>
      </div>
    </div>
  );
};

export default TemplateGroups;
